import { engineComponent } from "neo-common";
import { Controller } from "../Controller";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { BonusView } from "./BonusView";
import { BonusModel } from "./BonusModel";
import { Machine } from "../Machine";

@engineComponent(ComponentTypes.Controller)
export class BonusController extends Controller {
    public static readonly StartReceived: string = "eventStartReceived";
    public static readonly SpinReceived: string = "eventSpinReceived";
    public static readonly RespinReceived: string = "eventRespinReceived";
    public static readonly EndReceived: string = "eventEndReceived";
    public static readonly MachineStopped: string = "eventMachineStopped";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly WinAnimatorTotalStart: string = "eventWinAnimatorTotalStart";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly IntroFinished: string = "eventIntroFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";

    protected _view: BonusView;
    protected _model: BonusModel;

    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof BonusView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new BonusModel(this);
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initIntro(): void {
        this._view.initIntro();
    }

    start(): void {
        this._model.start();
    }

    spin(): void {
        this._model.spin();
        this._view.spin();
    }

    respin(reels: number): void {
        this._model.respin();
        this._view.respin(reels);
    }

    end(): void {
        this._model.end();
    }

    stop(): void {
        this._view.stop();
    }

    startReceived(): void {
        this._view.startReceived();
        this.emit(BonusController.StartReceived);
    }

    spinReceived(): void {
        this._view.spinReceived();
        this.emit(BonusController.SpinReceived);
    }

    respinReceived(): void {
        Machine.Respin = true;
        this._view.spinReceived();
        this.emit(BonusController.RespinReceived);
    }

    endReceived(): void {
        this._view.endReceived();
        this.emit(BonusController.EndReceived);
    }

    machineStopped(): void {
        this.emit(BonusController.MachineStopped);
    }

    winCalculationFinished(): void {
        this.emit(BonusController.WinCalculationFinished);
    }

    winAnimatorTotalStart(): void {
        this.emit(BonusController.WinAnimatorTotalStart);
    }

    allWinsFinished(): void {
        this.emit(BonusController.AllWinsFinished);
    }

    intro(long: boolean = false, previousModule: string): void {
        this._view.intro(long, previousModule);
    }

    introFinished(): void {
        this.emit(BonusController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(BonusController.OutroFinished);
    }

    enable(): void {
        this._view.enable();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Bonus/BonusController.ts
 **/